// extracted by mini-css-extract-plugin
export var heading = "profile-module--heading--e028d";
export var profile = "profile-module--profile--46869";